document.addEventListener('DOMContentLoaded', function() {
    var announcement = document.querySelector('.m-announcement-bar');
    if (!announcement) {
        return;
    }

    var height = announcement.offsetHeight;
    document.body.style.setProperty('--announcement-height', height + 'px');

    var announcementId = announcement.getAttribute('data-announcement');
    var close = document.querySelector('.m-announcement-bar-close');
    close.addEventListener('click', function(event) {
        var date = new Date();
        date.setTime(date.getTime() + (31 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = "announcement-" + announcementId + "=true; " + expires + "; path=/";

        announcement.style.transition = "height 0.5s ease";
        announcement.style.height = 0;
        announcement.style.overflow = "hidden";

        document.body.style.setProperty('--announcement-height', '');

        event.preventDefault();
    });
});
